import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchForm from './SearchForm';
import SearchResult from './SearchResult';

// eslint-disable-next-line react/prefer-stateless-function
class ContentSearch extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <SearchForm />
        <SearchResult />
      </React.Fragment>
    );
  }
}

ContentSearch.propTypes = {};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentSearch);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentSearch/ContentSearch.js